export const adminConstants = {
  SET_ADMIN_TENANT: 'SET_ADMIN_TENANT',
}
